import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { color } from '../../../value/types/color/index.mjs';
import { filter } from '../../../value/types/complex/filter.mjs';
import { numberValueTypes } from './number.mjs';

/**
 * A map of default value types for common values
 */
var defaultValueTypes = _objectSpread(_objectSpread({}, numberValueTypes), {}, {
  // Color props
  color: color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter: filter,
  WebkitFilter: filter
});
/**
 * Gets the default ValueType for the provided value key
 */
var getDefaultValueType = function getDefaultValueType(key) {
  return defaultValueTypes[key];
};
export { defaultValueTypes, getDefaultValueType };